export default __webpack_public_path__ + "static/media/03_raised_btn_800.53306614.gif";